import { useParams } from 'react-router-dom';
import './carga.css';
import { useState } from 'react';
import useOtrasDenuncias from '../general/useOtrasDenuncias';

function formatDate(inputDate) {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  if (Number.isNaN(date.getTime())) return '';
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

function Fila({ d, destacada }) {
  const clase = destacada ? 'textoBodyTablaOtrasDenuncias bg-success text-white' : 'textoBodyTablaOtrasDenuncias';
  const clase2 = destacada ? 'textoBodyTablaOtrasDenuncias2 bg-success text-white' : 'textoBodyTablaOtrasDenuncias2';
  return (
    <tr>
      <td className={clase}>{d?.nroStro ? d.nroStro.toString().substring(3) : ''}</td>
      <td className={clase2}>{d?.nombreConductorAseg}</td>
      <td className={clase2}>{d?.dom}</td>
      <td className={clase2}>{d?.pza}</td>
      <td className={clase}>{formatDate(d?.fechaStro)}</td>
      <td className={clase}>{formatDate(d?.qnx?.ados_fech_ini)}</td>
      <td className={clase}>{formatDate(d?.qnx?.ados_fech_fin)}</td>
      <td className={clase}>{d?.catStro}</td>
    </tr>
  );
}

function Titulo({ children }) {
  return (
    <tr>
      <td colSpan={8} style={{ borderTop: '1px solid #cbd5e1', paddingTop: '14px' }}>
        <h5 className='mt-3'>{children}</h5>
      </td>
    </tr>
  );
}

export default function TablaOtrasDenuncias() {
  const id = useParams().id;
  const { actual, porPoliza, polizaAnterior, porPatente, cargando, error, recargar } = useOtrasDenuncias(id);
  const [verAnteriores, setVerAnteriores] = useState(false);

  if (cargando) {
    return (
      <div className='center'>
        <div className='spinner-border text-success center' role='status'>
          <span className='visually-hidden center'>Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='center flex-column gap-3 mt-4 text-center'>
        <i className='bi bi-exclamation-triangle' style={{ fontSize: '28px', color: '#e11d48' }}></i>
        <p className='mb-0'>{error}</p>
        <button className='btn btn-outline-success btn-sm' onClick={recargar}>
          Reintentar
        </button>
      </div>
    );
  }

  if (!actual) return null;

  return (
    <section>
      <table className='mt-3 table'>
        <thead>
          <tr>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Nro Stro</h6>
            </th>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Asegurado</h6>
            </th>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Patente</h6>
            </th>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Pol/Pres</h6>
            </th>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Fecha Stro</h6>
            </th>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Inicio Vigencia</h6>
            </th>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Fin Vigencia</h6>
            </th>
            <th scope='col'>
              <h6 className='textoHeaderTablaOtrasDenuncias'>Tipo Stro</h6>
            </th>
          </tr>
        </thead>
        <tbody>
          <Fila d={actual} destacada />

          <Titulo>{porPoliza.length ? 'Por Poliza' : 'No existen Otros con la misma Poliza'}</Titulo>
          {porPoliza.map(p => (
            <Fila key={`pol-${p.id}`} d={p} />
          ))}

          {polizaAnterior.length ? (
            <>
              <tr>
                <td colSpan={8} style={{ borderTop: '1px solid #cbd5e1', paddingTop: '14px' }}>
                  <h5 className='mt-3 d-flex align-items-center gap-2'>
                    Mismo nro de póliza, titular anterior
                    <span className='badge bg-secondary'>{polizaAnterior.length}</span>
                    <button className='btn btn-link btn-sm p-0' onClick={() => setVerAnteriores(v => !v)}>
                      {verAnteriores ? 'Ocultar' : 'Ver'}
                    </button>
                  </h5>
                  <small className='text-muted'>El número de póliza fue reutilizado: estos siniestros son de una vigencia anterior.</small>
                </td>
              </tr>
              {verAnteriores ? polizaAnterior.map(p => <Fila key={`ant-${p.id}`} d={p} />) : null}
            </>
          ) : null}

          <Titulo>{porPatente.length ? 'Por Patente' : 'No existen Otros con la misma Patente'}</Titulo>
          {porPatente.map(p => (
            <Fila key={`pat-${p.id}`} d={p} />
          ))}
        </tbody>
      </table>
    </section>
  );
}
